module.exports = __webpack_public_path__ + "img/hamburguesa.30e3e0a1.jpeg";